// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b0280849","732":"890bdc9e","977":"3b863bbd"}[chunkId] + ".chunk.js";
};